// services/paymentService.js
import { customFetch } from './baseService';

const endpoint = 'payments';

const paymentService = {
  // Tạo yêu cầu thanh toán qua VNPay
  payWithVNPay: async (paymentData) => {
    return customFetch(`${endpoint}/pay/vnpay`, {
      method: 'POST',
      body: paymentData,
    });
  },

  // Xử lý thông báo từ VNPay
  vnpNotify: async (notificationData) => {
    return customFetch(`${endpoint}/notify/vnpay`, {
      method: 'POST',
      body: notificationData,
    });
  },

  // Xử lý kết quả thanh toán VNPay
  vnpReturn: async (params) => {
    return customFetch(`${endpoint}/return/vnpay`, {
      method: 'GET',
      params,
    });
  },

  // Tạo yêu cầu thanh toán qua MoMo
  payWithMoMo: async (paymentData) => {
    return customFetch(`${endpoint}/pay/momo`, {
      method: 'POST',
      body: paymentData,
    });
  },

  // Xử lý thông báo từ MoMo
  momoNotify: async (notificationData) => {
    return customFetch(`${endpoint}/notify/momo`, {
      method: 'POST',
      body: notificationData,
    });
  },

  // Xử lý kết quả thanh toán MoMo
  momoReturn: async (params) => {
    return customFetch(`${endpoint}/return/momo`, {
      method: 'GET',
      params,
    });
  },
};

export default paymentService;
